// extracted by css-extract-rspack-plugin
export default {"pageWrapper":"WaiverTemplateForm_pageWrapper__ItyZQ","formWrapper":"WaiverTemplateForm_formWrapper__hO-X2"};